import { Box, ColumnLayout, Container, SpaceBetween, Spinner } from '@cloudscape-design/components'
import React, { useEffect, useState } from 'react'

import TypeVehicle from './tyre_temperature'
import CategoryVehicle from './tyre_pressure'
import LocationVehicle from './tyre_battery'
import StatusVehicle from './vehicle-status-chart'
import Pressure from './tyre_pressure'
import Temperature from './tyre_temperature'
import Battery from './tyre_battery'
import { TyreTable } from './data list tyre/data'
import { generateClient } from 'aws-amplify/api'
import { ListTyresQueryVariables } from '../../../../API'
import { listTyres } from '../../../../graphql/queries'

// Summary component (belum responsive)

const Summary = () => {

  const [listTyre, setListTyre] = useState<TyreTable[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  async function fetchOverview(limit = 100) {
    try {
      const client = generateClient();
      let nextToken: string | null = null;
      let allTyres: TyreTable[] = [];
      do {
        const variables: ListTyresQueryVariables = { limit, nextToken };
        let response = await client.graphql({
          query: listTyres,
          authMode: 'userPool',
          variables,
        });

        const tyress = response.data.listTyres.items;
        nextToken = response.data.listTyres.nextToken ?? null;

        // eslint-disable-next-line no-loop-func
        const newTyres: TyreTable[] = tyress.map(tyre => {
          const status = Boolean(tyre.status);
          return {
            id: tyre.id,
            tyreId: tyre.position ?? 0,
            sn: tyre.serialnumber ?? "",
            sensorId: tyre.sensorid ?? 0,
            brand: tyre.brand ?? "",
            typetyre: tyre.typetyre ?? "",
            VehicleCode: tyre.vehiclecode ?? "",
            pressure: tyre.pressure ?? 0,
            temperature: tyre.temperature ?? 0,
            battery: tyre.battery ?? 0,
            Status: status,
          };
        });

        allTyres = [...allTyres, ...newTyres];
      } while (nextToken);

      setListTyre(allTyres);
      setIsLoading(false);
    } catch (err) {
      console.log("error fetching todos : ", err);
    }
  }
  useEffect(() => {
    fetchOverview();
  }, [])

  if(isLoading){
    return (
      <Container fitHeight={true}>
      <ColumnLayout columns={1} minColumnWidth={100}>
      <div style={{ textAlign: "center", marginTop: "60px", marginBottom :"60px" }}>
        <Spinner size="large" /> 
        <Box variant="p">Loading tyre summary data...</Box>
      </div>
      </ColumnLayout>
    </Container>
    )
  }


  return (
    <Container fitHeight={true}>
      <ColumnLayout columns={3} minColumnWidth={100}>
        <div>
          <Pressure tyres={listTyre} />
        </div>
        <div>
          <Temperature tyres={listTyre}/>
        </div>
        <div>
          <Battery tyres={listTyre} />
        </div>

      </ColumnLayout>
    </Container>
  )
}

export default Summary
